var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reports-sidebar-button",class:{
    selected: _vm.selected === _vm.item,
    disabled: !this.isSuperAdmin && _vm.item.disabled
  },on:{"click":_vm.toggle}},[_vm._v("\n  "+_vm._s(_vm.item.name)+"\n  "),(_vm.item.dev)?_c('dev-tag',{staticStyle:{"margin-left":"15px"},attrs:{"position":"relative"}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-886c412e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/Reports/Sidebar/ReportsSidebarButton.vue
// module id = null
// module chunks = 